import Utils from "./utils";
import Verge from 'verge';
import $ from "jquery";

/**
 *
 */
class Menu{

	/**
	 *
	 * @param options
	 */
	constructor(Bulb){

		Utils.debug('Construct menu');

		this.bulb = Bulb;
		this.menuOpen = false;
		this.$menu = $('.main-menu');
		this.$btn = $('.main-menu__btn');
		this.TL_menu = false;
		this.$menuContainer = $('.main-menu ul:first-child');
		this.$links = $('.main-menu__content__links__item');
		this.tl = gsap.timeline();
		this.init();
		$('.sub-menu').hide();

		this.menu = document.querySelectorAll('.main-menu nav > div > ul > li')
		this.submenu = document.querySelectorAll('.main-menu nav > div > ul > li .sub-menu')

		let that = this
		this.menu.forEach((el,i)=>{
			el.addEventListener('mouseenter',()=>{
				// el.addEventListener('click',()=>{
				// 	gsap.set('.menu-item.active', {display:'none'})
				// });
				gsap.set('.menu-item.active > ul', {display:'none'})
				el.classList.add('active')
				gsap.fromTo(el.querySelector(':scope > ul'), .5, {display: 'flex', autoAlpha: 0}, {autoAlpha: 1, ease: 'Expo.easeInOut'});
			})
			el.addEventListener('mouseleave',()=>{
				// gsap.fromTo(that.submenu[i], .1, {display: 'flex', autoAlpha: 1}, {autoAlpha: 0,ease: 'Expo.easeInOut',onComplete:()=>{
				// 		gsap.set(that.submenu[i],{display:'none'})
				// 		el.classList.remove('active')
				// 	}});
				gsap.set(el.querySelector(':scope > ul'),{display:'none'})
			})

		})


	}


	/**
	 * Init
	 */
	init(){
		Utils.debug('Init menu');
		let self = this;
		self.$btn.on('click', function(e){
			e.preventDefault();
			if(!self.menuOpen){
				self.open();
			} else {
				self.close();
			}
		});
	}


	/**
	 * Open
	 */
	open(){

		Utils.debug('Menu:Open');
		$('#app').trigger('sketch::pause');
		this.tl.clear();
		let self = this;
		self.menuOpen = true;
		self.$menu.addClass('main-menu_open');
		self.$btn.addClass('main-menu__btn_open');

		self.tl.add([
			gsap.to(self.$menu.find('.main-menu__content'), 0.4, {autoAlpha: 1, ease: Expo.easeInOut}),
			gsap.fromTo(self.$menuContainer, {xPercent: -100}, {xPercent: 10, ease: 'Expo.easeInOut'}),
			gsap.fromTo(self.$links, {yPercent: 500}, {yPercent: 0, ease: 'Expo.easeInOut', stagger: .1, duration: .6 })
		])
	}


	/**
	 * Close
	 */
	close(){

		Utils.debug('Menu:Close');
		$('#app').trigger('sketch::ready');
		let self = this;
		self.menuOpen = false;
		self.$menu.removeClass('main-menu_open');
		self.$btn.removeClass('main-menu__btn_open');

		self.tl.add([
			gsap.to(self.$menuContainer, .5, {xPercent: -100, ease: 'Expo.easeInOut'}),
			gsap.to(self.$links, .5, {yPercent: 500, ease: 'Expo.easeInOut' }),
			gsap.to(self.$menu.find('.main-menu__content'), 1, {autoAlpha: 0, ease: Expo.easeInOut}),
		])


	}



}


module.exports = Menu;
